import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getLang } from "@/util/config";

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
        load: 'currentOnly',
        lng: getLang(),
        backend: {
            loadPath: function (lngs: Array<string>, namespaces: Array<string>) {
                if (lngs.includes('dev')) {
                    return '';
                }
                const langName = (lngs[0].toLowerCase() === 'zh-tw' || lngs[0].toLowerCase() === 'zh-tc') ? 'zh-hk' : lngs[0].toLowerCase();
                return `${window.location.origin}/static-statistics/project/${ langName }.json`;
            },
            parse: function (data: string) {
                const obj = eval("(" + data + ")");
                return obj[Object.keys(obj)[0]];
            },
            queryStringParams: { v: '1.0' }
        },
        debug: false,
        interpolation: {
            escapeValue: false
        },
    });
export default i18n;
